var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: {
        value: _vm.open,
        persistent: "",
        "max-width": "350",
        "content-class": "task-item-dialog"
      }
    },
    [
      _c(
        "v-card",
        { staticClass: "home-form-container", attrs: { color: "#f0f0ef" } },
        [
          _vm.editedItem !== null
            ? _c(
                "v-card-text",
                {
                  staticClass: "home-form-container",
                  staticStyle: { "text-align": "left", padding: "4px 0 0 0" }
                },
                [
                  _c(
                    "v-layout",
                    { attrs: { row: "", wrap: "" } },
                    [
                      _c("input-field", {
                        attrs: {
                          label: _vm.$tc("Number", 1),
                          "variable-name": "bt_num_pol",
                          "input-type": "text",
                          size: "50",
                          required: ""
                        },
                        model: {
                          value: _vm.editedItem.bt_num_pol,
                          callback: function($$v) {
                            _vm.$set(_vm.editedItem, "bt_num_pol", $$v)
                          },
                          expression: "editedItem.bt_num_pol"
                        }
                      }),
                      _vm._v(" "),
                      _c("input-field", {
                        attrs: {
                          label: _vm.$tc("Floor", 1),
                          "variable-name": "bt_floor",
                          "input-type": "int",
                          size: "50",
                          required: ""
                        },
                        model: {
                          value: _vm.editedItem.bt_floor,
                          callback: function($$v) {
                            _vm.$set(_vm.editedItem, "bt_floor", $$v)
                          },
                          expression: "editedItem.bt_floor"
                        }
                      }),
                      _vm._v(" "),
                      _c("input-field", {
                        attrs: {
                          label: _vm.$tc("Fraction", 1),
                          "variable-name": "bt_fraction",
                          "input-type": "text",
                          size: "50",
                          required: ""
                        },
                        model: {
                          value: _vm.editedItem.bt_fraction,
                          callback: function($$v) {
                            _vm.$set(_vm.editedItem, "bt_fraction", $$v)
                          },
                          expression: "editedItem.bt_fraction"
                        }
                      }),
                      _vm._v(" "),
                      _c("input-field", {
                        attrs: {
                          label: _vm.$tc("Type", 1),
                          "variable-name": "bt_type",
                          "input-type": "select",
                          selectOptions: "list_bd_category_type",
                          size: "50",
                          required: ""
                        },
                        model: {
                          value: _vm.editedItem.bt_type,
                          callback: function($$v) {
                            _vm.$set(_vm.editedItem, "bt_type", $$v)
                          },
                          expression: "editedItem.bt_type"
                        }
                      }),
                      _vm._v(" "),
                      _c("input-field", {
                        attrs: {
                          label: _vm.$t("Description"),
                          "variable-name": "bt_description",
                          size: "large",
                          inputType: "text"
                        },
                        model: {
                          value: _vm.editedItem.bt_description,
                          callback: function($$v) {
                            _vm.$set(_vm.editedItem, "bt_description", $$v)
                          },
                          expression: "editedItem.bt_description"
                        }
                      }),
                      _vm._v(" "),
                      _c("input-field", {
                        attrs: {
                          label: _vm.$tc("Address", 1),
                          "variable-name": "bt_address",
                          size: "large",
                          inputType: "text"
                        },
                        model: {
                          value: _vm.editedItem.bt_address,
                          callback: function($$v) {
                            _vm.$set(_vm.editedItem, "bt_address", $$v)
                          },
                          expression: "editedItem.bt_address"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { text: "", "x-small": "" },
                  on: { click: _vm.close }
                },
                [_vm._v("\n        " + _vm._s(_vm.$t("Cancel")) + "\n      ")]
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticStyle: { "margin-right": "10px" },
                  attrs: { "x-small": "", color: "accent" },
                  on: { click: _vm.applyChanges }
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.$t("ApplyChanges")) + "\n      "
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0c829d7e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c829d7e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/Buildings/Typification/TypificationEditionDialog.vue
// module id = null
// module chunks = 